import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  fill({ params: { text } }) {
    // The composer's content field is a `<textarea name=content>` (the standardized message input),
    // so match by name only — `input[name=content]` no longer selects it.
    const input = this.element.querySelector("[name=content]")
    if (!input) return

    input.value = text
    input.closest("form").requestSubmit()
  }
}
